import React, { useMemo, useState, useRef, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'
import Page from 'containers/Page'
import Breadcrumbs from 'components/Breadcrumbs'
import { Helmet } from 'react-helmet'

import languages from 'data/languages/list'
import languageNames from 'data/languages/messages'
import { messages as routes } from 'routes'
import useUrl from 'useUrl'

const Wrapper = (props) => (
  <React.Fragment>
    <div className="hidden sm:block" style={{ columnCount: 4 }} {...props} />
  </React.Fragment>
)

const Languages = (props) => {
  const { formatMessage, locale } = useIntl()
  const queryRef = useRef(null)
  const [query, setQuery] = useState('')

  const languageMap = useMemo(
    () =>
      languages
        .map((lang) => {
          lang.name = formatMessage(languageNames[lang.key])
          return lang
        })
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .reduce((map, language) => {
          const firstLetter = language.name[0]

          if (!map[firstLetter]) {
            map[firstLetter] = []
          }

          if (language.name.toLowerCase().includes(query.toLowerCase())) {
            map[firstLetter].push(language)
          }

          return map
        }, {}),
    [query]
  )

  useEffect(() => {
    queryRef.current.focus()
  }, [])

  return (
    <Page>
      <Helmet>
        <title>{formatMessage(messages.metaTitle)}</title>
        <meta
          name="description"
          content={formatMessage(messages.metaDescription)}
        />
      </Helmet>

      <div className="max-w-screen-xl mx-auto">
        <Breadcrumbs />
      </div>

      <div className="max-w-screen-xl mx-auto p-4">
        <input
          tabIndex={0}
          ref={queryRef}
          className="w-full px-3 py-2 text border border-gray-300 mb-10"
          placeholder={formatMessage(messages.queryPlaceholder)}
          value={query}
          onChange={({ target: { value } }) => setQuery(value)}
        />

        {Object.entries({ 'sm:hidden': 2, 'hidden sm:block': 4 }).map(
          ([classNames, columnCount]) => (
            <div
              className={classNames}
              style={{ columnCount }}
              key={`col-${columnCount}`}
            >
              {Object.entries(languageMap).map(([firstLetter, languages]) => (
                <div
                  className="mb-10"
                  key={`${columnCount}-languages-${firstLetter}`}
                >
                  <div className="text-gray-900 font-medium uppercase text-sm mb-2">
                    {firstLetter}
                  </div>
                  {languages.length ? (
                    languages.map((language, i) => (
                      <a
                        key={`${columnCount}-${language.key}-${i}`}
                        className="block text-primary hover:text-primary-darker focus:text-primary-darker transform delay-100 duration-100 hover:translate-x-2 focus:translate-x-2"
                        href={useUrl(
                          locale,
                          formatMessage(routes.exploreByLanguage, {
                            language: formatMessage(
                              languageNames[language.key + 'URL']
                            ),
                          })
                        )}
                      >
                        {language.name}
                      </a>
                    ))
                  ) : (
                    <div className="text-gray-500 text-sm">
                      <FormattedMessage {...messages.empty} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </Page>
  )
}

export default Languages
